module.exports = __webpack_public_path__ + "assets/fdd6d8253bfe8ae425487a85758c9338.png";